import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useFetchPriceAndFinance from './useFetchPriceAndFinance';

const PriceAndFinanceContext = createContext({
  data: null,
  isLoading: false,
  hasError: false,
  isSellingProvince: true,
});

export const usePriceAndFinanceDetails = () => {
  const { data, isLoading, hasError, isSellingProvince } = useContext(PriceAndFinanceContext);
  const pricing = { ...data?.msrp, msrpDiscountprice: data?.cashPurchase?.total };
  const finance = data?.finance;
  const frieghtPDIFeesCost = data?.cashPurchase?.fees;
  return { isLoading, hasError, isSellingProvince, pricing, finance, data, frieghtPDIFeesCost };
};

const PriceAndFinanceProvider = ({ children }) => {
  const { data, isLoading, hasError, isSellingProvince } = useFetchPriceAndFinance();
  const value = useMemo(
    () => ({ data, isLoading, hasError, isSellingProvince }),
    [data, hasError, isLoading, isSellingProvince],
  );

  return <PriceAndFinanceContext.Provider value={value}>{children}</PriceAndFinanceContext.Provider>;
};

PriceAndFinanceProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default PriceAndFinanceProvider;
